import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  alert: {
    display: 'flex',
    alignItems: 'center',
  },
});

export default useStyles;
